export default function validate(values) {
  let errors = {};
  if (!values.fullname) {
    errors.fullname = 'Please enter your name';
  } else if (!(chkSpecialchar(values.fullname.trim()))) {
    errors.fullname = 'Please enter valid name';
  } else if (ischar(values.fullname.trim()) === false) {
    errors.fullname = 'Please enter valid name';
  } else if (values.fullname.trim() == '') {
    errors.fullname = 'Please enter valid name';
  }

  if (!values.mobile) {
    errors.mobile = 'Please enter your mobile number';
  } else if (values.mobile.length !== 10) {
    errors.mobile = 'Your mobile number must contain 10 digits';
  } else if (isInteger(values.mobile) === false) {
    errors.mobile = 'Please enter numbers only';
  } else if (values.mobile === "0000000000" || values.mobile === "6666666666" || values.mobile === "7777777777" || values.mobile === "8888888888" || values.mobile === "9999999999" || values.mobile === "9876543210" || values.mobile === "0123456789") {
    errors.mobile = 'Please enter valid mobile number';

  } else if (/^[6-9][0-9]{9}$/.test(values.mobile) === false) {
    errors.mobile = 'Please enter valid mobile number';

  }

  if (!values.email) {
    errors.email = 'Email address is required';
  } else if (!/^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/.test(values.email)) {
    errors.email = 'Email address is invalid.';
  }

  if (!values.city) {
    errors.city = 'Please select city';
  } else if (!(chkSpecialchar(values.city.trim()))) {
    errors.city = 'Please select valid city';
  } else if (ischar(values.city.trim()) === false) {
    errors.city = 'Please select valid city';
  } else if (values.city.trim() == '') {
    errors.city = 'Please select valid city';
  }

  if (!values.dob) {
    errors.dob = 'Please select your date of birth';
  } else if (values.dob.trim() == '') {
    errors.dob = 'Please select valid date of birth';
  }
  // if (!values.date) {
  //   errors.date = 'Please enter your date';
  // } else if (values.date.trim() == '') {
  //   errors.date = 'Please enter valid date';
  // }
  if (!values.address) {
    errors.address = 'Please enter your address';
  }else if (values.address.trim() == '') {
    errors.address = 'Please enter valid address';
  }

  if (!values.pincode) {
    errors.pincode = 'Please enter your pincode';
  } else if (values.pincode.trim() == '') {
    errors.pincode = 'Please enter valid pincode';
  }
  if (!values.stadium || values.stadium === 'Select Stadium' ) {
    errors.stadium = 'Please select stadium';
  }
  if (!values.termsconditions) {
    errors.termsconditions = 'Please accept terms & conditions';
  }
  if (!values.choice1 && !values.choice2 && !values.choice3) {
    errors.choice1 = 'Please select any 2';
  }else if ((!values.choice1 && !values.choice2) || (!values.choice1 && !values.choice3) || (!values.choice2 && !values.choice3)) {
    errors.choice1 = 'Please select any 2';
  }

  return errors;


  function chkSpecialchar(s) {
    var i;
    for (i = 0; i < s.length; i++) {
      // Check that current character is number.

      var c = s.charAt(i);
      if (c === "!" || c === "#" || c === "'" || c === "^" || c === ":" || c === "\"" || c === "*" || c === ":" || c === "(" || c === ")" || c === "+" || c === "=" || c === "|" || c === "<" || c === ">" || c === "%" || c === "?" || c === "/" || c === "@") {
        return false;
      }
    }
    // All characters are numbers.
    return true;
  }

  function ischar(s) {
    var i;
    for (i = 0; i < s.length; i++) {
      // Check that current character is number.

      var c = s.charAt(i);
      if (!((c < "0") || (c > "9"))) {
        return false;
      }
    }
    // All characters are numbers.
    return true;
  }

  function isInteger(s) {
    var i;
    for (i = 0; i < s.length; i++) {
      // Check that current character is number.

      var c = s.charAt(i);
      if (((c < "0") || (c > "9"))) {
        return false;
      }
    }
    // All characters are numbers.
    return true;
  }

  // START the "trim" function
  // function trim(inputString) {
  //   // Removes leading and trailing spaces from the passed string. Also removes
  //   // consecutive spaces and replaces it with one space. If something besides
  //   // a string is passed in (null, custom object, etc.) then return the input.
  //   if (typeof inputString !== "string") { return inputString; }

  //   var retValue = inputString;
  //   var ch = retValue.substring(0, 1);

  //   while (ch === " ") { // Check for spaces at the beginning of the string
  //     retValue = retValue.substring(1, retValue.length);
  //     ch = retValue.substring(0, 1);
  //   }

  //   ch = retValue.substring(retValue.length - 1, retValue.length);

  //   while (ch === " ") { // Check for spaces at the end of the string
  //     retValue = retValue.substring(0, retValue.length - 1);
  //     ch = retValue.substring(retValue.length - 1, retValue.length);
  //   }

  //   while (retValue.indexOf("  ") !== -1) { // Note that there are two spaces in the string - look for multiple spaces within the string
  //     retValue = retValue.substring(0, retValue.indexOf("  ")) + retValue.substring(retValue.indexOf("  ") + 1, retValue.length); // Again, there are two spaces in each of the strings
  //   }

  //   return retValue; // Return the trimmed string back to the user
  // }

};

